module.exports = __webpack_public_path__ + "img/default-2.1181d8c9.svg";